import axios from "axios";
import { API_BASE_URL, API_BASE_URL1 } from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};

export const GetAllSecondaryDeploymentInchargeDetails = async () => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `SecondaryDeployment/GetAllSecondaryDeploymentIncharge`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
